// @flow

/**
 * Export grid gutter width.
 */

export const gridGutterWidth = 0;

/**
 * Export breakpoints.
 */

export const breakpoints = {
  base: 0,
  lg: 1200,
  md: 992,
  sm: 768,
  xl: 1440,
  xs: 480,
  xxs: 320
};

/**
 * Export `fixedHeight`.
 */

export const fixedHeight = {
  footer: '120px',
  navbar: '80px',
  navbarMobile: '68px'
};

/**
 * Z index.
 */

export const zIndex = {
  navbar: 100
};



// WEBPACK FOOTER //
// ../src/client/styles/layout.js